import React from "react";
import "../assets/css/main.css"; // Assure-toi que ton CSS global est bien chargé

const Footer = () => {
  return (
    <footer id="footer" className="footer accent-background">
      <div className="container">
        {/* Copyright */}
        <div className="copyright text-center">
          <p>
            © <span>Copyright</span>{" "}
            <strong className="px-1 sitename">Hovig Abechian</strong> <span>All Rights Reserved</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
